import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';

const PasswordSkeleton = () => {

    return (
        <Grid container spacing={2} justify="center" style={{width:"100%"}}>
            <Grid item size={12}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={55}
                    animation="wave"
                    style={{borderRadius:12}}
                />
            </Grid>
            <Grid item size={12}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={55}
                    animation="wave"
                    style={{borderRadius:12}}
                />
            </Grid>
        </Grid>

    );
};

export default PasswordSkeleton;
